import makeResultElement from './makeResultElement';

export default (resultsContainer, results) => {
	const isResultsEmpty = results === null;
	if (isResultsEmpty) {
		return;
	}

	const resultEls = results.map(({ text, link }) =>
		makeResultElement(text, link)
	);

	resultsContainer.replaceChildren(...resultEls);
};
